"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuelParams = exports.useParams = exports.getAvailableEngineTypes = void 0;
const react_1 = require("react");
const calculator_types_1 = require("../components/fleet-calculator/calculator-types");
const lodash_1 = require("lodash");
const getOption = (record, value) => ({
    value,
    label: record[value],
});
const getOptions = (record) => Object.keys(record).map((key) => getOption(record, key));
const getFuel = (fuelType, metadata) => {
    return metadata.fuels[fuelType];
};
const getAvailableEngineTypes = (fuelType, metadata) => metadata.combinations.fuels[fuelType];
exports.getAvailableEngineTypes = getAvailableEngineTypes;
const useParams = ({ defaultParams, setParams, }) => {
    const [localParams, setLocalParams] = (0, react_1.useState)(defaultParams);
    const setParamsHelper = (0, react_1.useCallback)((newParams) => {
        setLocalParams((prevParams) => ({ ...prevParams, ...newParams }));
    }, []);
    (0, react_1.useEffect)(() => {
        setParams(localParams);
    }, [localParams, setParams]);
    return {
        localParams,
        setParamsHelper,
    };
};
exports.useParams = useParams;
const useFuelParams = ({ defaultParams, metadata, isComparison, fuelIndex, setParams, }) => {
    const [localParams, setLocalParams] = (0, react_1.useState)(defaultParams);
    const [availableEngineTypes, setAvailableEngineTypes] = (0, react_1.useState)((0, calculator_types_1.isFuelParams)(localParams)
        ? (0, exports.getAvailableEngineTypes)(localParams.fuel_type ? localParams.fuel_type.toString() : "", metadata)
        : []);
    const setParamsHelper = (0, react_1.useCallback)((newParams) => {
        setLocalParams((prevParams) => ({ ...prevParams, ...newParams }));
    }, []);
    (0, react_1.useEffect)(() => {
        setParams(localParams, isComparison, fuelIndex);
    }, [localParams, setParams, isComparison, fuelIndex]);
    const fuelTypes = (0, lodash_1.mapValues)(metadata.fuels, (fuel) => fuel.description);
    const engineTypes = (0, lodash_1.mapValues)(metadata.engines, (engine) => engine.engine.description);
    const fuelName = localParams.fuel_type && fuelTypes[localParams.fuel_type];
    const engineOptions = getOptions((0, lodash_1.pick)(engineTypes, availableEngineTypes));
    const selectedEngineOption = getOption(engineTypes, localParams.engine_type ? localParams.engine_type.toString() : "");
    const onChangeFuelType = (0, react_1.useCallback)((fuelType, metadata) => {
        const fuelNumber = Number(fuelType);
        const fuel = getFuel(fuelNumber, metadata);
        const availableEngineTypes = (0, exports.getAvailableEngineTypes)(fuelType, metadata);
        const newEngineType = localParams.engine_type !== undefined &&
            availableEngineTypes.includes(localParams.engine_type)
            ? localParams.engine_type
            : availableEngineTypes[0];
        setAvailableEngineTypes(availableEngineTypes);
        setParamsHelper({
            fuel_type: fuelNumber,
            fuel_price: fuel.price,
            engine_type: newEngineType,
            engine_change_cost: fuel.default_engine_change_cost,
            engine_efficiency: metadata["efficiency-fuel-engine"][fuelType][newEngineType],
            intensity: isComparison
                ? metadata["intensity-fuel-engine"][fuelType][newEngineType]
                : undefined,
        });
    }, [metadata, localParams, setParamsHelper, setAvailableEngineTypes]);
    const onChangeEngineType = (0, react_1.useCallback)((engineType) => {
        if (localParams.fuel_type) {
            setParamsHelper({
                engine_type: Number(engineType),
                engine_efficiency: metadata["efficiency-fuel-engine"][localParams.fuel_type][engineType],
                intensity: isComparison
                    ? metadata["intensity-fuel-engine"][localParams.fuel_type][engineType]
                    : undefined,
            });
        }
    }, [metadata, localParams, setParamsHelper, setAvailableEngineTypes]);
    return {
        localParams,
        fuelName,
        engineOptions,
        selectedEngineOption,
        onChangeFuelType,
        onChangeEngineType,
        setParamsHelper,
    };
};
exports.useFuelParams = useFuelParams;
